import { h, Component } from 'preact';
import { Router } from 'preact-router';
import Match from 'preact-router/match';

import Header from './header';
import BoTimer from './timer';

import Home from '../routes/home';
import Settings from '../routes/settings';
import About from '../routes/about';

export default class App extends Component {

	constructor(props) {
    super(props);

    this.state = {
    }
  }


	componentDidMount(){
	}

	handleRoute = e => {
		this.currentUrl = e.url;
	};

	render() {
		return (
			<div id="app">
				<Router>
					<Home path="/" />
					<Settings path="/settings" />
					<About path="/about" />
				</Router>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js